import A from '../images/chords/A.png';
import A7 from '../images/chords/A7.png';
import Ab from '../images/chords/Ab.png';
import Am from '../images/chords/Am.png';
import Am7 from '../images/chords/Am7.png';
import Asus from '../images/chords/Asus.png';
import B from '../images/chords/B.png';
import B7 from '../images/chords/B7.png';
import Bb from '../images/chords/Bb.png';
import Bbm from '../images/chords/Bbm.png';
import Bm from '../images/chords/Bm.png';
import Bm7 from '../images/chords/Bm7.png';
import CSharpm from '../images/chords/C#m.png';
import C from '../images/chords/C.png';
import C6 from '../images/chords/C6.png';
import C7 from '../images/chords/C7.png';
import CoverE from '../images/chords/C:E.png';
import Cadd9 from '../images/chords/Cadd9.png';
import Cmaj7 from '../images/chords/Cmaj7.png';
import Cm from '../images/chords/Cm.png';
import D from '../images/chords/D.png';
import D4 from '../images/chords/D4.png';
import Dsixnine from '../images/chords/D6:9.png';
import D7 from '../images/chords/D7.png';
import DoverFSharp from '../images/chords/D:F#.png';
import Db from '../images/chords/Db.png';
import Dm from '../images/chords/Dm.png';
import Dm7 from '../images/chords/Dm7.png';
import Dsus from '../images/chords/Dsus.png';
import Dsus4 from '../images/chords/Dsus4.png';
import E from '../images/chords/E.png';
import E7 from '../images/chords/E7.png';
import EoverGSharp from '../images/chords/E:G#.png';
import Eb from '../images/chords/Eb.png';
import Em from '../images/chords/Em.png';
import Em7 from '../images/chords/Em7.png';
import FSharp from '../images/chords/F#.png';
import FSharpm from '../images/chords/F#m.png';
import F from '../images/chords/F.png';
import F9 from '../images/chords/F9.png';
import Fm from '../images/chords/Fm.png';
import GSharp from '../images/chords/G#.png';
import G from '../images/chords/G.png';
import G6 from '../images/chords/G6.png';
import G7 from '../images/chords/G7.png';
import G9 from '../images/chords/G9.png';
import GoverD from '../images/chords/G:D.png';
import Gb from '../images/chords/Gb.png';
import { ChordType } from '../types';

export const ChordList: ChordType[] = [
	{ flat: false, major: true, sharp: false, title: 'A', url: A },
	{ flat: false, major: true, sharp: false, title: 'A7', url: A7 },
	{ flat: true, major: true, sharp: false, title: 'Ab', url: Ab },
	{ flat: false, major: false, sharp: false, title: 'Am', url: Am },
	{ flat: false, major: false, sharp: false, title: 'Am7', url: Am7 },
	{ flat: false, major: true, sharp: false, title: 'Asus', url: Asus },
	{ flat: false, major: true, sharp: false, title: 'B', url: B },
	{ flat: false, major: true, sharp: false, title: 'B7', url: B7 },
	{ flat: true, major: true, sharp: false, title: 'Bb', url: Bb },
	{ flat: true, major: false, sharp: false, title: 'Bbm', url: Bbm },
	{ flat: false, major: false, sharp: false, title: 'Bm', url: Bm },
	{ flat: false, major: false, sharp: false, title: 'Bm7', url: Bm7 },
	{ flat: false, major: true, sharp: false, title: 'C', url: C },
	{ flat: false, major: true, sharp: false, title: 'C6', url: C6 },
	{ flat: false, major: true, sharp: false, title: 'C7', url: C7 },
	{ flat: false, major: true, sharp: false, title: 'C/E', url: CoverE },
	{ flat: false, major: true, sharp: false, title: 'Cadd9', url: Cadd9 },
	{ flat: false, major: true, sharp: false, title: 'Cmaj7', url: Cmaj7 },
	{ flat: false, major: false, sharp: false, title: 'Cm', url: Cm },
	{ flat: false, major: false, sharp: true, title: 'C#m', url: CSharpm },
	{ flat: false, major: true, sharp: false, title: 'D', url: D },
	{ flat: false, major: true, sharp: false, title: 'D4', url: D4 },
	{ flat: false, major: true, sharp: false, title: 'D6/9', url: Dsixnine },
	{ flat: false, major: true, sharp: false, title: 'D7', url: D7 },
	{ flat: false, major: true, sharp: false, title: 'D/F#', url: DoverFSharp },
	{ flat: true, major: true, sharp: false, title: 'Db', url: Db },
	{ flat: false, major: false, sharp: false, title: 'Dm', url: Dm },
	{ flat: false, major: false, sharp: false, title: 'Dm7', url: Dm7 },
	{ flat: false, major: true, sharp: false, title: 'Dsus', url: Dsus },
	{ flat: false, major: true, sharp: false, title: 'Dsus4', url: Dsus4 },
	{ flat: false, major: true, sharp: false, title: 'E', url: E },
	{ flat: false, major: true, sharp: false, title: 'E7', url: E7 },
	{ flat: true, major: true, sharp: false, title: 'Eb', url: Eb },
	{ flat: false, major: true, sharp: false, title: 'E/G#', url: EoverGSharp },
	{ flat: false, major: false, sharp: false, title: 'Em', url: Em },
	{ flat: false, major: false, sharp: false, title: 'Em7', url: Em7 },
	{ flat: false, major: true, sharp: false, title: 'F', url: F },
	{ flat: false, major: true, sharp: false, title: 'F9', url: F9 },
	{ flat: false, major: true, sharp: true, title: 'F#', url: FSharp },
	{ flat: false, major: false, sharp: true, title: 'F#m', url: FSharpm },
	{ flat: false, major: false, sharp: false, title: 'Fm', url: Fm },
	{ flat: false, major: true, sharp: false, title: 'G', url: G },
	{ flat: false, major: true, sharp: true, title: 'G#', url: GSharp },
	{ flat: false, major: true, sharp: false, title: 'G6', url: G6 },
	{ flat: false, major: true, sharp: false, title: 'G7', url: G7 },
	{ flat: false, major: true, sharp: false, title: 'G9', url: G9 },
	{ flat: false, major: true, sharp: false, title: 'G/D', url: GoverD },
	{ flat: true, major: true, sharp: false, title: 'Gb', url: Gb },
];
